<template>
  <a-modal
    :title="title"
    :width="600"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    :okText="$t('disp.btn.confirm')"
    :centered="true"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" @keyup.enter.native="handleOk()">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('disp.jobName')">
          <a-input
            :placeholder="$t('disp.ph.input', [$t('disp.jobName')])"
            v-decorator="['jobClassName', { rules: [{ required: true, message: $t('disp.rules.require') }] }]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('disp.cronExpression')">
          <j-cron
            ref="innerVueCron"
            v-decorator="[
              'cronExpression',
              { rules: [{ required: true, message: $t('disp.rules.require') }], initialValue: '* * * * * ? *' },
            ]"
            @change="setCorn"
          ></j-cron>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('disp.parameter')">
          <a-textarea
            :placeholder="$t('disp.ph.input', [$t('disp.parameter')])"
            :autoSize="{ minRows: 4 }"
            v-decorator="['parameter', {}]"
            @keyup.enter.stop
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('disp.note')">
          <a-textarea
            :placeholder="$t('disp.ph.input', [$t('disp.note')])"
            :autoSize="{ minRows: 4 }"
            v-decorator="['description', {}]"
            @keyup.enter.stop
          />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import { httpAction } from '@/api/manage'
import JCron from '@/components/JCron'
import pick from 'lodash/pick'
// import moment from "moment"

export default {
  name: 'QuartzJobModal',
  components: {
    JCron,
  },
  data() {
    return {
      title: '操作',
      buttonStyle: 'solid',
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 19 },
      },
      cron: {
        label: '',
        value: '',
      },
      loading: false,
      form: this.$form.createForm(this),
      url: {
        add: '/sys/quartzJob/add',
        edit: '/sys/quartzJob/edit',
      },
    }
  },
  created() {},
  methods: {
    add() {
      this.edit({})
    },
    edit(record) {
      let that = this
      that.form.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(this.model, 'jobClassName', 'cronExpression', 'parameter', 'description', 'status')
        )
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      const that = this
      // フォーム検証をトリガー
      this.form.validateFields((err, values) => {
        if (!err) {
          if (typeof values.cronExpression == 'undefined' || Object.keys(values.cronExpression).length == 0) {
            this.$message.warning(this.$t('disp.ph.input', [this.$t('disp.cronExpression')]))
            return false
          }

          that.loading = true
          let httpurl = ''
          let method = ''
          if (!this.model.id) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'put'
          }
          let formData = Object.assign(this.model, values)
          //時間フォーマットする

          httpAction(httpurl, formData, method)
            .then((res) => {
              if (res.success) {
                that.$message.success(this.$t(res.message))
                that.$emit('ok')
              }
            })
            .finally(() => {
              that.loading = false
              that.close()
            })
        }
      })
    },
    handleCancel() {
      this.close()
    },
    setCorn(data) {
      this.$nextTick(() => {
        this.model.cronExpression = data
      })
    },
  },
}
</script>

<style scoped></style>
